import React, { FC } from 'react'

import { ChipsContainer } from '@Components/Chips/ChipsContainer'
import { DiscountChip } from '@Components/Chips/DiscountChip'
import { NewChip } from '@Components/Chips/NewChip'
import { OutOfStockChip } from '@Components/Chips/OutOfStockChip'
import { TwoForOneChip } from '@Components/Chips/TwoForOneChip'
import ProductTileImage from '@Components/Product/Tile/ProductTileImage'
import TileWrapper from '@Components/Product/Tile/TileWrapper'
import { AddToWishList } from '@Components/WishList/addToWishList'
import { Product as ProductMParticle } from '@Events/ECommerce'
import { Product as ProductGTM } from '@Globals/Google/DataLayer'

import {
  BeforePrice,
  BrandAndPriceWrapper,
  BrandWrapper,
  InfoWrapper,
  InnerWrapper,
  OutOfStockWrapper,
  Price,
  PriceWrapper,
  ProductTileWrapper,
  ProductTitle,
  WishlistContainer,
} from './styledElements'

export interface ProductTileProps {
  beforePrice?: string
  brandTitle?: string
  disallowLineBreakInTitle?: boolean
  discount?: {
    context?: string
    percentage?: number
  }
  greyOverlay?: boolean
  // TODO: temporary hack to get around product tile structure
  gtmProduct: ProductGTM
  hoverImage?: string | null
  id: string
  isNew?: boolean
  isOutOfStock?: boolean
  // TODO: temporary hack to get around product tile structure
  mParticleProduct: ProductMParticle
  personalization?: boolean
  price: string
  primaryImage?: string
  productType?: string
  sourceID?: string
  title: string
  url: string
}

export const ProductTile: FC<ProductTileProps> = ({
  beforePrice,
  brandTitle,
  disallowLineBreakInTitle = false,
  discount,
  greyOverlay = false,
  gtmProduct,
  hoverImage = null,
  id,
  isNew = false,
  isOutOfStock = false,
  mParticleProduct,
  personalization = false,
  price,
  primaryImage,
  productType,
  sourceID,
  title,
  url,
}) => {
  const showChips = isNew || discount?.percentage || discount?.context !== '' || productType === 'glasses'
  return (
    <TileWrapper
      id={id}
      personalization={personalization}
      sourceID={sourceID}
      title={title}
      url={url}
    >
      <ProductTileWrapper>
        <ProductTileImage
          greyOverlay={greyOverlay}
          hoverImageURL={hoverImage}
          imageURL={primaryImage}
          personalization={personalization}
          title={title}
        />
        {!personalization && (
          <WishlistContainer>
            <AddToWishList gtmProduct={gtmProduct} id={id} mParticleProduct={mParticleProduct} size="small" />
          </WishlistContainer>
        )}

        {/* Info */}
        <InfoWrapper active={greyOverlay}>
          <BrandAndPriceWrapper>
            <BrandWrapper>{brandTitle}</BrandWrapper>
            {
              // TODO add new price logic here.
            }
            <PriceWrapper>
              {!!beforePrice && (
                <BeforePrice>
                  {beforePrice}
                </BeforePrice>
              )}
              <Price beforePrice={beforePrice}>
                {price}
              </Price>
            </PriceWrapper>
          </BrandAndPriceWrapper>
          <ProductTitle singleLine={disallowLineBreakInTitle}>
            {title}
          </ProductTitle>
        </InfoWrapper>

        {/* Top chips */}
        {showChips && (
          <ChipsContainer>
            {isNew && <NewChip />}
            {discount && <DiscountChip discount={discount} />}
            {productType === 'glasses' && <TwoForOneChip />}
          </ChipsContainer>
        )}

        {/* Ouf of stock */}
        {isOutOfStock && (
          <OutOfStockWrapper>
            <InnerWrapper>
              <OutOfStockChip />
            </InnerWrapper>
          </OutOfStockWrapper>
        )}
      </ProductTileWrapper>
    </TileWrapper>
  )
}
